export const UNABLE_TO_SUBSCRIBE = 'We are unable to add your email. This may be due to an invalid email address. Please&nbsp;check and try again.';
export const HAS_BEEN_SUBSCRIBED = 'has been subscribed!';
export const HAS_BEEN_SIGNED_UP = 'has been signed up!';
